import React, { useEffect, useState } from 'react';
import './Landing.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import PouchDB from 'pouchdb-browser';
//import { closeMenu } from '../functions/functions';
import Objeto from '../object/Objeto';
import { Link } from 'react-router-dom';
import { urls } from '../router/urls';
import Skeleton from 'react-loading-skeleton';
import { FORMATS_MAP } from '../../data/constants';

const Page = () => {
  new PouchDB('gestor_contenidos_db', { revs_limit: 1 });
  new PouchDB('gestor_contenidos_agrupaciones', {
    auto_compaction: true,
    revs_limit: 1
  });

  const { t, i18n } = useTranslation();

  const [datos, setData] = useState([]);
  /*
  const [datosTopRatedResources, setDataTopRatedResources] = useState([]);
  const [datosNewResources, setDataNewResources] = useState([]);
  const [datosTopGroups, setDataTopGroups] = useState([]);
  const [
    resourcesFormatCountersData,
    setDataResourcesFormatCounters
  ] = useState({});
  
  const [search, setSearch] = useState([]);
  const [onBusqueda, setOnBusqueda] = useState(false);
  */
  const [loading, setLoading] = useState(true);

  /*
  const updateSearch = e => {
    setSearch(e.target.value);
  };
  */

  const getObjects = () => {
    axios
      .get(urls.url_api + '/api/featured-contents/')
      .then(response => {
        setData(response.data.results);
      })
      .then(() => setLoading(false));
  };

  /*
  const getTopRatedResources = () => {
    axios
      .get(urls.url_api + '/api/top-resource-objects/?count=2')
      .then(response => {
        setDataTopRatedResources(response.data.results);
      });
  };

  const getNewResources = () => {
    axios.get(urls.url_api + '/api/new-resources/').then(response => {
      setDataNewResources(response.data.results);
    });
  };

  const getTopGroups = () => {
    axios.get(urls.url_api + '/api/most-visited-group/').then(response => {
      setDataTopGroups(response.data.results);
    });
  };
  */

  /*const getDataResourcesFormatCounters = () => {
    axios
      .get(urls.url_api + '/api/resource-objects/resources_format_counters/')
      .then(response => {
        setDataResourcesFormatCounters(response.data);
      });
  };*/

  useEffect(() => {
    //closeMenu();
    window.scrollTo(0, 0);
    i18n.changeLanguage(localStorage.getItem('lang'));
    getObjects();
    //getTopRatedResources();
    //getNewResources();
    //getTopGroups();
    //getDataResourcesFormatCounters();
  }, [i18n]);

  return (
    <div className='landing'>
      {/* redirect se activa cuando se da envia el formulario de busqueda */}

      {/* onBusqueda ? (
        <Redirect push to={`/${urls.busqueda}/?query=${search}`} />
      ) : (
        ''
      ) */}

      <section className='landing-banner' aria-label={t('landing_banner_title_aria')}>
        <h1>{t('landing_banner_title')}</h1>
        <h3 dangerouslySetInnerHTML={{ __html: t('landing_banner_subtitle') }}></h3>
        <Link to="/colecciones" role="link" aria-label={t('landing_banner_explore_collections_aria')}>{t('landing_banner_explore_collections')}</Link>
      </section>
      <section className='landing-featured' aria-labelledby="featured-content-title">
        <div className="landing-recommended">
          <span id="featured-content-title">{t('contenidos_destacados')}</span>
        </div>
        <div className="row content-pwa">
          {/* skeleton antes de la carga */}
          {datos.length === 0 && loading && (
            <>
              {[...Array(4)].map((_, index) => (
                <div className="col-12 col-md-3 objeto-pwa" key={index}>
                  <div className={'m-3'}>
                    <Skeleton height={150} />
                    <Skeleton count={5} />
                  </div>
                </div>
              ))}
            </>
          )}

          {/* top recursos */}
          {datos.map((objeto, index) => (
            <div className="col-12 col-md-3 objeto-pwa" key={index}>
              <Objeto
                key={index}
                is_group={objeto.group_type}
                downloable={
                  objeto.rights === null ? '' : objeto.rights.description.download
                }
                img={urls.url_api + objeto.image}
                titulo={objeto.general.title.value}
                resources={objeto.relation}
                descripcion={objeto.general.description[0].value}
                id={objeto.id}
                classification={objeto.classification}
                nivel_educativo={
                  objeto.educational === null
                    ? ''
                    : objeto.educational.context[0].educative_level
                }
                poblacion_objetivo={
                  objeto.educational === null
                    ? ''
                    : objeto.educational.intented_end_user_role[0]
                }
                licencia={
                  objeto.rights === null
                    ? ''
                    : objeto.rights.copyright_and_other_restrictions.license
                }
                location={objeto.technical[0] ? objeto.technical[0].location : ''}
                extension={
                  objeto.technical[0] ? objeto.technical[0].format.extension : ''
                }
                taxon={''}
              />
            </div>
          ))}
        </div>
        <div className="more-collect">
          <Link to="/colecciones" role="link" aria-label={t('landing_more_collections_aria')}>{t('landing_more_collections')}</Link>
        </div>
      </section>
      <section className='landing-education-fase' aria-labelledby="education-title">
        <div className='content-education-fase'>
          <h2 id="education-title">{t('landing_education_title')}</h2>
          <div className="images-education-fase">
            <Link to="#" className='primary-fase'  aria-label={t('landing_education_primary_aria')}>{t('landing_education_primary')}</Link>
            <Link to="#" className='basic-fase'  aria-label={t('landing_education_basic_aria')}>{t('landing_education_basic')}</Link>
            <Link to="#" className='superior-fase'  aria-label={t('landing_education_superior_aria')}>{t('landing_education_superior')}</Link>
            <Link to="#" className='work-fase'  aria-label={t('landing_education_work_aria')}>{t('landing_education_work')}</Link>
          </div>
        </div>
      </section>
      <section className='landing-areas' aria-labelledby="areas-title">
        <h2 id="areas-title">{t('landing_areas_title')}</h2>
        <div className='d-flex elements'>
          <div className='area-item science-area'>
            <img src="/static/images/rework/science-card.png" alt="science-area" className='area-card-img'/>
            <img src="/static/images/rework/vector-science-area.svg" alt="vector-area" className='vector-area'/>
            <div>
              <h1>{t('landing_science_math_title')}</h1>
              <p>{t('landing_science_math_description')}</p>
              <Link to="#" aria-label={t('landing_view_resources_science_aria')}>{t('landing_view_resources')} <i className="far fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
          <div className='area-item language-area'>
            <img src="/static/images/rework/language-card.png" alt="language-area" className='area-card-img'/>
            <img src="/static/images/rework/vector-language-area.svg" alt="vector-area" className='vector-area'/>
            <div>
              <h1>{t('landing_language_humanities_title')}</h1>
              <p>{t('landing_language_humanities_description')}</p>
              <Link to="#" aria-label={t('landing_view_resources_language_aria')}>{t('landing_view_resources')} <i className="far fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
          <div className='area-item habits-area'>
            <img src="/static/images/rework/habits-card.png" alt="habits-area" className='area-card-img'/>
            <img src="/static/images/rework/vector-habits-area.svg" alt="vector-area" className='vector-area'/>
            <div>
              <h1>{t('landing_habits_title')}</h1>
              <p>{t('landing_habits_description')}</p>
              <Link to="#" aria-label={t('landing_view_resources_habits_aria')}>{t('landing_view_resources')} <i className="far fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
        </div>
        <div className='d-flex elements-2'>
          <div className='area-item art-area'>
            <img src="/static/images/rework/art-card.png" alt="art-area" className='area-card-img'/>
            <img src="/static/images/rework/vector-art-area.svg" alt="vector-area" />
            <div>
              <h1>{t('landing_art_culture_title')}</h1>
              <p>{t('landing_art_culture_description')}</p>
              <Link to="#" aria-label={t('landing_view_resources_art_aria')}>{t('landing_view_resources')} <i className="far fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
          <div className='area-item health-area'>
              <img src="/static/images/rework/health-card.png" alt="health-area" className='area-card-img'/>
            <img src="/static/images/rework/vector-health-area.svg" alt="vector-area" />
            <div>
              <h1>{t('landing_health_wellness_title')}</h1>
              <p>{t('landing_health_wellness_description')}</p>
              <Link to="#" aria-label={t('landing_view_resources_health_aria')}>{t('landing_view_resources')} <i className="far fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
        </div>
      </section>

      {/** Contadores recursos **/}
      <section className="row mt-0 mr-1 mb-0 ml-0 counters-section">
        <h2 id="learn-how-to-learn-title">{t('landing_learn_how_to_learn')}</h2>
        <div className="howlearn col-sm-12 align-content-center justify-content-evenly flex-wrap" role="list" aria-labelledby="learn-how-to-learn-title">
          {[
              'textual',
              'graphic',
              'sonorous',
              'audiovisual',
              'multimedia',
              'interactive'
            ].map((key, index) => (
              <div
                className="resource-format-counter-container d-flex flex-column align-content-center align-items-center justify-content-end"
                key={key}
                role="listitem"
              >
                <Link
                  to={`/${urls.busqueda}/?format-filter=${FORMATS_MAP[key]}`}
                  className="bc-link"
                  aria-label={t(`landing_resource_format_${key}_aria`)}
                >
                  <div className="d-flex flex-column justify-content-between align-items-center">
                    <img
                      src={
                        '/static/images/rework/'+
                        key +
                        '-fase.png'
                      }
                      className="mb-2"
                      alt={t(`landing_resource_format_${key}_alt`)}
                    />
                    <span className="resource-format-counter-title">
                      {FORMATS_MAP[key]}
                    </span>
                    {/*<span></span>*/}
                  </div>
                </Link>
              </div>
            ))}
        </div>
      </section>
      <section className='landing-joinus' aria-labelledby="joinus-title">
        <div className='joinus-content'>
          <h1 id="joinus-title">{t('landing_joinus_title')}</h1>
          <h2>{t('landing_joinus_subtitle')}</h2>
          <Link>{t('landing_joinus_more')}</Link>
        </div>
      </section>
    </div>
  );
};

export default Page;
